module.exports = __webpack_public_path__ + "img/zb1.3cbabdb2.png";